export default "__VITE_ASSET__8Q$rA8PH__"